import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

function AuthRouteFallback() {
    return (
        <div className="d-flex min-vh-100 align-items-center justify-content-center bg-light">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando sesión</span>
            </div>
        </div>
    );
}

function AdminRoute({ children, authResolved, isAuthenticated, isSuperAdmin }) {
    if (!authResolved) {
        return <AuthRouteFallback />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return isSuperAdmin ? <>{children}</> : <Navigate to="/" replace />;
}

const mapStateToProps = (state) => ({
    authResolved: state.Auth.authResolved,
    isAuthenticated: state.Auth.isAuthenticated,
    isSuperAdmin: state.Auth.isSuperAdmin
})

export default connect(mapStateToProps)(AdminRoute);